// extracted by mini-css-extract-plugin
export default {"LeftArrow":"LeftArrow"};